var _g, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuBurgerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Header_Menu_Icon",
    "data-name": "Header Menu Icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.304 15.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_64_",
    transform: "translate(0.905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3820",
    "data-name": "Path 3820",
    d: "M101.124,572.786H83.881a1.185,1.185,0,0,1,0-2.36h17.243a1.185,1.185,0,0,1,0,2.36Z",
    transform: "translate(-82.803 -570.426)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3821",
    "data-name": "Path 3821",
    d: "M101.124,585.174H83.881a1.185,1.185,0,0,1,0-2.36h17.243a1.185,1.185,0,0,1,0,2.36Z",
    transform: "translate(-82.803 -576.772)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3822",
    "data-name": "Path 3822",
    d: "M96.547,597.561H83.983a1.18,1.18,0,1,1,0-2.36H96.547a1.18,1.18,0,1,1,0,2.36Z",
    transform: "translate(-82.803 -583.117)",
    fill: "#199b8b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3823",
    "data-name": "Path 3823",
    d: "M82.3,574.2H99.54a1.185,1.185,0,0,0,0-2.36H82.3a1.185,1.185,0,0,0,0,2.36Z",
    transform: "translate(-81.219 -571.033)",
    fill: "#199b8b",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3824",
    "data-name": "Path 3824",
    d: "M82.3,586.59H99.54a1.185,1.185,0,0,0,0-2.36H82.3a1.185,1.185,0,0,0,0,2.36Z",
    transform: "translate(-81.219 -577.434)",
    fill: "#199b8b",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3825",
    "data-name": "Path 3825",
    d: "M82.4,598.978H94.963a1.18,1.18,0,1,0,0-2.36H82.4a1.18,1.18,0,1,0,0,2.36Z",
    transform: "translate(-81.219 -583.724)",
    fill: "#199b8b",
    opacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBurgerIcon);
export default __webpack_public_path__ + "static/media/menu-burger-icon.194467ed4940d18af3fa43c4c12d4785.svg";
export { ForwardRef as ReactComponent };